/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Approval_Failed_LabelInputs */

const en_style_guide_manager_approval_failed_label = /** @type {(inputs: Style_Guide_Manager_Approval_Failed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approval Failed`)
};

const fr_style_guide_manager_approval_failed_label = /** @type {(inputs: Style_Guide_Manager_Approval_Failed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approbation echouee`)
};

const de_style_guide_manager_approval_failed_label = /** @type {(inputs: Style_Guide_Manager_Approval_Failed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genehmigung fehlgeschlagen`)
};

const it_style_guide_manager_approval_failed_label = /** @type {(inputs: Style_Guide_Manager_Approval_Failed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approvazione fallita`)
};

const ru_style_guide_manager_approval_failed_label = /** @type {(inputs: Style_Guide_Manager_Approval_Failed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Одобрение не пройдено`)
};

const es_style_guide_manager_approval_failed_label = /** @type {(inputs: Style_Guide_Manager_Approval_Failed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprobación fallida`)
};

const zh_cn2_style_guide_manager_approval_failed_label = /** @type {(inputs: Style_Guide_Manager_Approval_Failed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`审批失败`)
};

const ja_style_guide_manager_approval_failed_label = /** @type {(inputs: Style_Guide_Manager_Approval_Failed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`承認に失敗しました`)
};

const hi_style_guide_manager_approval_failed_label = /** @type {(inputs: Style_Guide_Manager_Approval_Failed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुमोदन विफल`)
};

const pt_pt2_style_guide_manager_approval_failed_label = /** @type {(inputs: Style_Guide_Manager_Approval_Failed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A aprovação falhou.`)
};

/**
* | output |
* | --- |
* | "Approval Failed" |
*
* @param {Style_Guide_Manager_Approval_Failed_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_approval_failed_label = /** @type {((inputs?: Style_Guide_Manager_Approval_Failed_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Approval_Failed_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_approval_failed_label(inputs)
	if (locale === "de") return de_style_guide_manager_approval_failed_label(inputs)
	if (locale === "it") return it_style_guide_manager_approval_failed_label(inputs)
	if (locale === "ru") return ru_style_guide_manager_approval_failed_label(inputs)
	if (locale === "es") return es_style_guide_manager_approval_failed_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_approval_failed_label(inputs)
	if (locale === "ja") return ja_style_guide_manager_approval_failed_label(inputs)
	if (locale === "hi") return hi_style_guide_manager_approval_failed_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_approval_failed_label(inputs)
	return en_style_guide_manager_approval_failed_label(inputs)
});